module.exports = __webpack_public_path__ + "static/media/app-update-warning-monsters.ca55ae71.png";